module.exports = __webpack_public_path__ + "static/img/aboutUsPic.fa84040.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/aboutUsPic.png
// module id = 8I6u
// module chunks = 1